import React, { Component } from 'react'
import All from './all'
import HighIntention from './high_intention'
import NoFollowUp from './no_followup'
import NotConnected from './not_connected'
import { Tabs } from 'hljd'
import store from '../store'
import Styles from './style.module.less'
import { observer } from 'mobx-react'
import OrderForm from './orderForm'

const TabPane = Tabs.TabPane

@observer
export default class extends Component {
  render() {
    let { dataLoad, dataOk, dataNot } = store
    return (
      <div>
        <div className={Styles.orderBox}>
          <Tabs
            activeKey={store.tabkey}
            onChange={store.callback}
            type="card"
            style={{ marginTop: 30 }}
          >
            <TabPane tab="全部" key="all">
              <All />
            </TabPane>
            <TabPane
              tab={
                <h5>
                  确认中{' '}
                  {dataLoad != '' ? (
                    <i className={Styles.irt}>{dataLoad}</i>
                  ) : (
                    ''
                  )}
                </h5>
              }
              key="0"
            >
              <HighIntention />
            </TabPane>
            <TabPane
              tab={
                <h5>
                  通过{' '}
                  {dataOk != '' ? <i className={Styles.irt}>{dataOk}</i> : ''}
                </h5>
              }
              key="1"
            >
              <NoFollowUp />
            </TabPane>
            <TabPane
              tab={
                <h5>
                  不通过{' '}
                  {dataNot != '' ? <i className={Styles.irt}>{dataNot}</i> : ''}
                </h5>
              }
              key="2"
            >
              <NotConnected />
            </TabPane>
          </Tabs>
        </div>
        <OrderForm />
      </div>
    )
  }
}
